import { useEffect, useState } from 'react';

// DS v1 breakpoint for tablet-sm was 640px
const MOBILE_BREAKPOINT = 640;

type UseResponsiveReturn = {
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
};

/**
 * Custom hook to detect screen size breakpoints
 * Replaces useResponsive from DS v1
 */
export function useResponsive(): UseResponsiveReturn {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    };

    // Check on mount
    checkMobile();

    // Listen for resize events
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  return {
    isMobile,
    isTablet:
      !isMobile && typeof window !== 'undefined' && window.innerWidth < 1024,
    isDesktop: typeof window !== 'undefined' && window.innerWidth >= 1024
  };
}
